var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftArrowWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15 27.5002C8.10625 27.5002 2.5 21.8927 2.5 15.0002C2.5 8.10774 8.10625 2.50024 15 2.50024C21.8925 2.50024 27.5 8.10774 27.5 15.0002C27.5 21.8927 21.8925 27.5002 15 27.5002Z",
    fill: "#C7C7C7",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.803 20.2761C16.5643 20.2761 16.3243 20.1849 16.1418 20.0024L11.783 15.6649C11.6068 15.4886 11.508 15.2499 11.508 14.9999C11.508 14.7511 11.6068 14.5124 11.783 14.3361L16.1418 9.99613C16.508 9.63113 17.1005 9.63113 17.4668 9.99863C17.8318 10.3661 17.8305 10.9599 17.4643 11.3249L13.773 14.9999L17.4643 18.6749C17.8305 19.0399 17.8318 19.6324 17.4668 19.9999C17.2843 20.1849 17.043 20.2761 16.803 20.2761Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowWhite);
export default __webpack_public_path__ + "static/media/left-arrow-white.8bda36d666a0b47cfbb35e8752d0e292.svg";
export { ForwardRef as ReactComponent };